import { useEffect, useState } from "react";
import _ from "underscore";
import MapView from "./MapView";
import config from "../config";
import { Link } from "react-router-dom";

function PlacesMap(props) {
	const [data, setData] = useState([]);

	useEffect(() => {
		fetch(config.apiRoot+'farms?limit=2000&origin=true')
			.then(res => res.json())
			.then(json => setData(_.filter(json.results, (item) => item.lat && item.lng)));
	}, []);

	return <div>
		<MapView mapData={data} zoom={6} circleMarkers={true} popupContentFunc={(item) => <div>
			<div className="text-lg mb-2">{item.name}</div>
			{
				item.document_count && <div className="text-md mb-2">{item.document_count} {window.l('skjöl')}</div>
			}
			<Link to={'/archive?stadur='+item.id}>{window.l('View documents from this place')}</Link>
		</div>} />
	</div>
}

export default PlacesMap;